
import * as types from '../Actions/a.survey'

export default function Survey(state = {}, action) {
    switch (action.type) {
        case types.QUESTIONS_GETALL:

            return Object.assign({}, state, {
                Questions: action.payload
            })
        case types.ANSWER_ADD:
            {
                let list = state.Answers.find(item =>
                    item.QuestionId == action.payload.QuestionId);

                if (list !== undefined && list.length !== 0) {// if row has already been added
                    if (action.payload.AnswersType == 1)// if checkbox
                    {
                        list.Answers.push(action.payload.Answers[0]);
                        return state;
                    }
                    else {
                        list.Answers = [];
                        list.Answers.push(action.payload.Answers[0]);
                        return state;
                    }
                }
                else {
                    return Object.assign({}, state, {
                        Answers: [...state.Answers, action.payload]
                    })
                }
            }
        case types.ANSWER_REMOVE:
            {
                //just for checkout
                let newArray = state.Answers;
                console.log(newArray);
                let findAnswer = state.Answers.find(item => item.QuestionId === action.payload.QuestionId).Answers.filter(object => object.Id !== action.payload.AnswerId);

                newArray = newArray.filter(item => item.QuestionId !== action.payload.QuestionId);
                if (findAnswer.length > 0) {//if has other answers
                    const obj = {
                        QuestionId: action.payload.QuestionId,
                        AnswersType: action.payload.AnswersType,
                        Answers: findAnswer
                    };
                    newArray.push(obj);
                }

                return Object.assign({}, state, {
                    Answers: newArray
                });
            }

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/Reducers/r.survey.jsx